import moment from 'moment';

import validators from '@utils/validators';
import {TIME_TYPE_FIXED, TIME_TYPE_MARGIN} from '@modules/events/forms/ArgosJob/ArgosJobModel';
import {convertToInt} from '@utils/helpers';

const START_ERROR_MESSAGE = 'The start time cannot be earlier than the current time.';
const END_ERROR_MESSAGE = 'The end time cannot be earlier than the current time.';

const validate = (values, props) => {
    const errors = {};

    Object.assign(errors, validators.required(values.job_definition, 'job_definition'));
    Object.assign(errors, validators.required(values.region, 'region'));
    Object.assign(errors, validators.required(values.entry_point, 'entry_point'));
    Object.assign(errors, validators.required(values.tunnel_clients, 'tunnel_clients'));
    Object.assign(errors, validators.required(values.third_party_client_tunnel, 'third_party_client_tunnel'));
    Object.assign(errors, validators.required(values.start_time, 'start_time'));
    Object.assign(errors, validators.required(values.end_time, 'end_time'));
    Object.assign(errors, validators.maxLength({value: values.argos_description, maxLength: 200}, 'argos_description'));

    if (!values.start_time_is_past) {
        if (values.start_time_type === TIME_TYPE_MARGIN) {
            Object.assign(errors, validators.required(values.start_time_margin, 'start_time_margin'));

            const {eventStartDatetime} = props.formParams;
            const margin = convertToInt(values.start_time_margin);
            const calculatedStart = moment(eventStartDatetime, 'YYYY-MM-DD HH:mm:ss').subtract(margin, 'minutes');

            if (calculatedStart.isSameOrBefore(moment())) {
                errors.start_time_margin = START_ERROR_MESSAGE;
            }
        }

        if (values.start_time_type === TIME_TYPE_FIXED) {
            Object.assign(errors, validators.required(values.start_time_fixed, 'start_time_fixed'));

            if (values.start_time_fixed && moment(values.start_time_fixed, 'YYYY-MM-DD HH:mm:ss').isSameOrBefore(moment())) {
                errors.start_time_fixed = START_ERROR_MESSAGE;
            }
        }
    }

    if (values.end_time_type === TIME_TYPE_MARGIN) {
        Object.assign(errors, validators.required(values.end_time_margin, 'end_time_margin'));

        const {eventEndDatetime} = props.formParams;
        const margin = convertToInt(values.end_time_margin);

        if (eventEndDatetime) {
            const calculatedEnd = moment(eventEndDatetime, 'YYYY-MM-DD HH:mm:ss').add(margin, 'minutes');
            const now = moment();

            if (calculatedEnd.isSameOrBefore(now)) {
                errors.end_time_margin = END_ERROR_MESSAGE;
            }
        }
    }

    if (values.end_time_type === TIME_TYPE_FIXED) {
        Object.assign(errors, validators.required(values.end_time_fixed, 'end_time_fixed'));

        if (values.end_time_fixed && moment(values.end_time_fixed, 'YYYY-MM-DD HH:mm:ss').isSameOrBefore(moment())) {
            errors.end_time_fixed = END_ERROR_MESSAGE;
        }
    }

    return errors;
};

export default validate;
